import Container from 'react-bootstrap/Container'
import React, { useMemo, useEffect, useState, useRef } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import MemberShip from '../models/Membership'
import MobTable from '../components/MobTable'
import Logo from '../assets/logo_sihapei_qr.png'
import ReminderDebtModal from '../components/Modals/ReminderDebtModal'
import Member, { MemberType } from '../models/Member'
import MembershipModal from '../components/MembershipModal'
import profilePicture from '../assets/default_user.png'
import moment from 'moment'
import InvoiceDetailModal from '../components/Modals/InvoiceDetailModal'
import { Badge } from 'react-bootstrap'
import MemberCardModal from '../components/Modals/MemberCardModalV3'
import UpgradeMembershipModal from '../components/Modals/UpgradeMembershipModal'
import Alert from '../components/Alert'
import Swal from 'sweetalert2'
import TextTranslator from '../util/TextTranslator'
import MemberCard from '../models/MemberCard'
import { Checkbox, FormControlLabel } from '@material-ui/core'
import Helper from '../util/Helper'
import { QRCode } from 'react-qrcode-logo'
import Palette from '../Palette'
import { Image, Layer, Stage, Text } from 'react-konva'
import jsPDF from 'jspdf'
import TextFormatter from '../util/TextFormatter'
import qrious from 'qrious'
import crypto from '../util/crypto'

let stageRef
let imageRef
// const releaseDate = new Date(Helper.convertMonthDayToFullDate(process.env.REACT_APP_RELEASE_DATE))
// const releaseGracePeriod = new Date(Helper.convertMonthDayToFullDate(process.env.REACT_APP_RELEASE_GRACE_PERIOD))
const GRACE_PERIOD = new Date(Helper.convertMonthDayToFullDate(process.env.REACT_APP_GRACE_PERIOD))

function InvoicePage(props) {
    const [profileData, setProfileData] = useState({})
    const [isOverDueMembership, setIsOverDueMembership] = useState(false)
    const [activeMemberData, setActiveMemberData] = useState(null)
    const [activeExtensionData, setActiveExtensionData] = useState(null)
    const [latestExtensionData, setLatestExtensionData] = useState(null)
    const [gracePeriod, setGracePeriod] = useState('')

    const [memberCarData, setMemberCardata] = useState(null)

    const [latestHistoryRegardlessOfValidity, setLatestHistoryRegardlessOfValidity] = useState([])

    const [showMemberCard, setShowMemberCard] = useState(false)
    const [showUpgradeModal, setShowUpgradeModal] = useState(false)
    const [printMemberCard, setPrintMemberCard] = useState(false)

    const [selectedInvoiceDetail, setSelectedInvoiceDetail] = useState(null)
    const [selectedCertificate, setSelectedCertificate] = useState(null)
    const [isValidMembership, setIsValidMembership] = useState(true)

    let memberModel = new Member()

    const fetchSelfData = async () => {
        try {
            let result = await memberModel.getMemberData()
            // if (result?.membership?.length > 0) {
            //   const validResult = result?.membership[0]
            //   if (moment(result?.grace_period).isBefore(new Date())) {
            //     const dueDateMembership = moment(validResult?.valid_until).add(30, 'days').format('DD/MM/YYYY');
            //     setIsValidMembership(false)
            //     setValidateMsg(`Harap selesaikan pembayaran sebelum tanggal ${dueDateMembership} atau fitur fitur anda akan dikunci`)
            //   } else if (moment().isAfter(result?.grace_period)) {
            //     setIsValidMembership(false)
            //     setValidateMsg(`Akun Sihapei Saudara telah dinonaktifkan. Harap selesaikan tunggakan Saudara dengan menghubungi Sekretariat HPI. `)
            //   } else {
            //     setIsValidMembership(true)
            //   }
            // }

            setProfileData(result)

            console.log('PROF PROFILE', result)
            console.log('PROF PROFILE', profileData?.member?.hpi_id)
        } catch (e) {
            console.log('ERROR' + e)
        }
    }

    const getMemberResultUrl = () => {
        const baseUrl = process.env.REACT_QR_CODE_BASE_URL || 'https://sihapei.hpi.or.id'
        return `${baseUrl}/result/${profileData?.member?.id}?ref=scan`
    }

    const fetchActiveMembership = async () => {
        let memberModel = new Member()
        try {
            let result = await memberModel.getActiveMembership()
            console.log('result active membership', result)
            setActiveExtensionData(result.extension)
            setActiveMemberData(result.active)
            setLatestExtensionData(result.latest)
            setLatestHistoryRegardlessOfValidity(result.latestRegardlessOfValidity)
            console.log('isi grace period', result.grace_period)
            setGracePeriod(result.grace_period)

            //add overdue here, overdue yang buat liat orang bisa perpanjang atau engga?
            if (result?.latestRegardlessOfValidity?.valid_until) {
                const validUntil = moment(result?.latestRegardlessOfValidity?.valid_until)

                //CEK UDA EXPIRED BELUM
                if (!validUntil.isAfter(moment(GRACE_PERIOD))) {
                    setIsOverDueMembership(true)
                } else {
                    //INI cek, jadi semisal
                    // if (moment().isAfter(moment(validUntil).add(1, "years"))) {
                    //   setIsOverDueMembership(false)
                    // }
                }
            }

            console.log('ACMEM', result)
        } catch (e) {
            console.log('ERROR' + e)
        }
    }

    console.log('is overdue', isOverDueMembership)

    const fetchMostRecentMemberCard = async () => {
        try {
            let result = await MemberCard.getMyMostRecentMemberCard()
            setMemberCardata(result)
        } catch (e) {
            console.log('ERROR' + e)
        }
    }

    const [showReminderDialog, setShowReminderDialog] = useState(false)
    const hasDebtMember = JSON.parse(localStorage.getItem('user'))?.has_debt
    useEffect(() => {
        if (hasDebtMember) {
            setShowReminderDialog(true)
        }

        fetchSelfData()
        fetchActiveMembership()
        fetchMostRecentMemberCard()
    }, [])

    let formatter = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'IDR',
    })
    const [invoiceData, setInvoiceData] = useState([])
    const [showMembership, setShowMemberShip] = useState(false)
    const [showPricesModal, setShowPricesModal] = useState(false)
    const [prices, setPrices] = useState([])
    const [showInvoice, setShowInvoice] = useState(false)
    const [validateMsg, setValidateMsg] = useState('')
    const membershipModels = new MemberShip()
    const qrRef = useRef(null)

    const [canvasWidth, setCanvasWidth] = useState(0)
    const [canvasHeight, setCanvasHeight] = useState(0)
    const canvasRef = useRef(null)
    const [qrImage, setQrImage] = useState(null)

    const [top, setTop] = useState(45)
    const [left, setLeft] = useState(50)
    const [topNumber, setTopNumber] = useState(8)
    const [leftNumber, setLeftNumber] = useState(5)
    const [topHPI, setTopHPI] = useState(49)
    const [leftHPI, setLeftHPI] = useState(50)
    const [topYear, setTopYear] = useState(35.92)
    const [leftYear, setLeftYear] = useState(54.7)
    const [topQR, setTopQR] = useState(70.2)
    const [leftQR, setLeftQR] = useState(46.7)
    const [fontSizeNumber, setFontSizeNumber] = useState(8)
    const [fontSizeHPI, setFontSizeHPI] = useState(8)
    const [fontSizeYear, setFontSizeYear] = useState(8)
    const [certNumPlaceholder, setCertNumPlaceholder] = useState('TSN-HPI/J/2025/T/L/id-en/001')
    const [fontSize, setFontSize] = useState(16)

    const [year, setYear] = useState(new Date().getFullYear())
    const [qrValue, setQrValue] = useState('')
    const [textColor, setTextColor] = useState('blue')

    const [imageBG, setImageBG] = useState(null)
    const [backgroundImageURL, setBackgroundImageURL] = useState(
        require('../assets/sertifikat_keanggotaan_new.png'),
    )
    const [urlQR, setUrlQR] = useState('https://sihapei.hpi.or.id/professional-certificate')

    const fetchInvoice = async () => {
        try {
            let result = await membershipModels.getAllHistory()
            if (result) {
                let tempResultLatest = result[0]
                tempResultLatest.show_certificate = true
                result[0] = tempResultLatest
                setInvoiceData(result)
                console.log('cekcek membership', result)
            }
        } catch (e) {}
    }

    const fetchPrices = async () => {
        try {
            let result = await membershipModels.getPrices()
            console.log('prices of member', result)
            if (result) {
                setPrices(result)
            }
            console.log('hubla', result)
        } catch (e) {
            console.log('error: ', e)
        }
    }

    useEffect(() => {
        fetchInvoice()
        fetchPrices()
    }, [])

    const getCertificateResultUrl = () => {
        let qr = qrValue !== '' ? qrValue : selectedCertificate?.certificate_token
        const baseUrl = process.env.REACT_QR_CODE_BASE_URL || 'https://sihapei.hpi.or.id'
        return `${baseUrl}/professional-certificate/${qr}`
    }

    const columns = useMemo(() => {
        let cols = [
            {
                Header: <p style={{ fontSize: '0.7em' }}>ID</p>,
                accessor: 'id',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    return <p style={{ fontSize: '0.7em' }}>{value.id}</p>
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Dibuat pada</p>,
                accessor: 'transaction',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.original
                    //console.log('cekcek', cellInfo)
                    return (
                        <p style={{ fontSize: '0.7em' }}>
                            {value.transaction?.created_at
                                ? moment(value.transaction?.created_at).format('DD/MM/YYYY HH:mm')
                                : moment(value.created_at).format('DD/MM/YYYY HH:mm')}
                        </p>
                    )
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Jatuh Tempo</p>,
                accessor: 'due_date',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.original
                    return (
                        <p style={{ fontSize: '0.7em' }}>
                            {value.transaction?.should_expire_at
                                ? moment(value.transaction?.should_expire_at).format(
                                      'DD/MM/YYYY HH:mm',
                                  )
                                : '-'}
                        </p>
                    )
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Total</p>,
                accessor: 'total',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    return (
                        <p style={{ fontSize: '0.7em' }}>
                            {formatter.format(value.transaction?.amount ?? 0)}
                        </p>
                    )
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Jenis Pembayaran</p>,
                accessor: 'type',
                Cell: (cellInfo) => {
                    let value = cellInfo.row.values
                    return (
                        <p style={{ fontSize: '0.6em' }}>
                            {value.transaction
                                ? TextTranslator.getTipeProduk(value.transaction?.type)
                                : 'Perpanjangan diluar sistem'}
                        </p>
                    )
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Status</p>,
                accessor: 'status',
                Cell: (cellInfo) => {
                    let rowInfo = cellInfo.row.values

                    let color = 'white'
                    let backgroundColor = ''
                    let label = ''
                    if (rowInfo.status === 'WAITING') {
                        backgroundColor = '#2700ff'
                        label = 'Menunggu'
                    } else if (rowInfo.status === 'CANCELLED') {
                        backgroundColor = '#000000'
                        label = 'Batal'
                    } else if (
                        rowInfo.status === 'ACTIVE' &&
                        profileData?.member?.membership_upgrade_status === 'WAITING'
                    ) {
                        backgroundColor = '#000000'
                        label = 'Menunggu Verifikasi'
                    } else if (
                        rowInfo.status === 'ACTIVE' ||
                        rowInfo.status === 'PAID' ||
                        rowInfo.status === 'REPLACED'
                    ) {
                        backgroundColor = '#779500'
                        rowInfo.status = 'PAID'
                        label = 'Lunas'
                    }
                    return (
                        <Badge
                            style={{
                                width: '100%',
                                textAlign: 'center',
                                backgroundColor: backgroundColor,
                                paddingTop: 5,
                                paddingBottom: 5,
                                fontSize: '0.7em',
                            }}
                            variant="primary"
                        >
                            {label}
                        </Badge>
                        // <p
                        //     style={{color: color, backgroundColor: backgroundColor}}
                        //     className="text-center"
                        // >
                        //
                        // </p>
                    )
                },
            },
        ]
        return cols
    })

    let currentValidStatus = () => {
        let latestHistoryStatus = 'ACTIVE'
        if (latestHistoryRegardlessOfValidity) {
            // console.log("CVS", new Date() < releaseGracePeriod, new Date(latestHistoryRegardlessOfValidity.valid_until) > releaseDate, moment(latestHistoryRegardlessOfValidity.valid_until).add(30, "days").isBefore(new Date()))
            // console.log("CVS", releaseDate, releaseGracePeriod, latestHistoryRegardlessOfValidity.valid_until)
            /* if(new Date() < releaseGracePeriod && new Date(latestHistoryRegardlessOfValidity.valid_until) > releaseDate){
        return "RELEASE_GRACE_PERIOD_WARNING"
      } */

            console.log('LHRV', latestHistoryRegardlessOfValidity)

            if (
                moment(latestHistoryRegardlessOfValidity.valid_until).get('year') <
                moment().get('year') - 1
            ) {
                if (latestHistoryRegardlessOfValidity.role === 'MUDA') {
                    return 'NON_ACTIVE'
                } else {
                    return 'DEBT'
                }
            }

            if (moment(latestHistoryRegardlessOfValidity.valid_until).isBefore(new Date())) {
                if (latestHistoryRegardlessOfValidity.role === 'MUDA') {
                    return 'NON_ACTIVE'
                }
                if (moment().isBefore(GRACE_PERIOD)) {
                    console.log('GPGP', 'JATUH')
                    return 'JATUH_TEMPO'
                } else {
                    console.log('GPGP', 'DEBT')
                    return 'DEBT'
                }
            }

            if (
                moment(latestHistoryRegardlessOfValidity.valid_until)
                    .subtract(30, 'days')
                    .isBefore(new Date())
            ) {
                return 'AKAN_JATUH_TEMPO'
            }
        } else {
            return 'NON_ACTIVE'
        }
        return latestHistoryStatus
    }

    let membershipExpiryStatus = currentValidStatus()

    console.log('LHRV', membershipExpiryStatus)

    if (membershipExpiryStatus === 'DEBT') {
        localStorage.removeItem('popUpReminder')
        localStorage.removeItem('user')
    }

    useEffect(() => {
        if (canvasRef.current) {
            // Generate QR code on a hidden canvas
            const qr = new qrious({
                element: canvasRef.current,
                value: `${urlQR}/${qrValue}`,
                size: 100,
            })
            // Set the canvas element as the image source for Konva
            setQrImage(canvasRef.current)
        }
    }, [qrValue])

    const handleViewCertificate = async () => {
        if (
            selectedCertificate &&
            !selectedCertificate.certificate_url &&
            selectedCertificate.role !== 'MUDA'
        ) {
            let token = crypto.generateRandomStringWithLength(10)
            setQrValue(token)

            await waitTimeout(200)

            const pdf = new jsPDF('l', 'mm', [297, 210], true)

            let resultPdf = stageRef.toDataURL({ pixelRatio: 4 })
            const blob = await (await fetch(resultPdf)).blob()

            let formData = new FormData()

            formData.append('upload', blob, blob.name)
            formData.append('certificate_number', certNumPlaceholder)
            formData.append('certificate_token', token)

            let uploadResult = await memberModel.uploadCertificateUrl(
                selectedCertificate.id,
                formData,
            )
        }
    }

    const interactions = [
        {
            condition: (rowInfo) => {
                return !!(
                    (rowInfo.transaction?.paid_status === 'WAIT_SNAP_NOTIFICATION' ||
                        rowInfo.transaction?.paid_status === 'PENDING') &&
                    rowInfo.transaction?.snap_payment_url
                )
            },
            name: <div style={{ fontSize: '0.7em' }}>Lanjut Bayar</div>,
            action: (rowInfo) => {
                window.open(rowInfo.transaction?.snap_payment_url, '_blank')
            },
        },
        {
            condition: (rowInfo) => {
                return false
                return !!(
                    (rowInfo.transaction?.paid_status === 'PENDING' ||
                        rowInfo.transaction?.paid_status === 'WAIT_SNAP_NOTIFICATION') &&
                    rowInfo.transaction?.snap_payment_url
                )
            },
            name: <div style={{ fontSize: '0.7em' }}>Change Payment Method</div>,
            action: async (rowInfo) => {
                try {
                    let membershipModel = new MemberShip()
                    let result = await membershipModel.changeMethod()
                    console.log(result)
                } catch (e) {
                    console.error(e)
                }
            },
        },
        {
            condition: (rowInfo) => {
                return !!(
                    rowInfo.transaction?.paid_status === 'SETTLEMENT' ||
                    rowInfo.transaction?.paid_status === 'CONFIRMED'
                )
            },
            name: <div style={{ fontSize: '0.8em' }}>Lihat Tanda Terima</div>,
            action: (registrant) => {
                console.log(registrant)
                setSelectedInvoiceDetail(registrant)
            },
        },
        {
            condition: (rowInfo) => {
                return profileData?.member?.membership_creation_status === 'DONE' && !!profileData?.member?.hpi_id && (profileData?.member?.membership_upgrade_status === 'DONE' || !profileData?.member?.membership_upgrade_status) && (!!rowInfo.certificate_url || (!!(rowInfo.role === 'PENUH') && rowInfo.show_certificate === true && (new Date(rowInfo.valid_until) > new Date())))
            },
            name: <div style={{ fontSize: '0.8em' }}>Lihat Dokumen</div>,
            action: (registrant) => {
                //console.log(registrant)
                setSelectedCertificate(registrant)
            },
        },
    ]

    const waitTimeout = (ms) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, ms)
        })
    }

    const initializeImage = (newImage) => {
        const tryImage = new window.Image()
        tryImage.src = newImage
            ? newImage
            : backgroundImageURL.default
            ? backgroundImageURL.default
            : backgroundImageURL
        tryImage.onload = () => {
            setImageBG(tryImage)
            imageRef?.getLayer().batchDraw()
        }
        // imgKey = Date.now()
    }

    const initializeCertNum = async () => {
        try {
            let latestNum = await memberModel.generateMembershipCertNum()

            console.log(latestNum)

            let year = new Date().getFullYear()

            let newCertNum = `HPI-00/SKPBP/${year}/${TextFormatter.zeroPadder(
                latestNum.newNumber,
                4,
            )}`

            setCertNumPlaceholder(newCertNum)
        } catch (e) {
            console.log('error', e)

            Swal.fire({
                title: 'Error',
                text: e.error_message ? e.error_message : 'An Error Occurred',
                icon: 'error',
                customClass: {
                    container: 'swal-z',
                },
            })
        }
    }

    useEffect(() => {
        initializeImage()
        initializeCertNum()
        setTimeout(() => {
            handleViewCertificate()
        }, 1000)
    }, [selectedCertificate])

    const renderNewEditor = () => {
        return (
            <div
                style={{ width: '100%' }}
                ref={(ref) => {
                    if (canvasWidth === 0 && ref !== undefined && ref?.clientWidth) {
                        console.log('cek ref', ref?.clientWidth)
                        setCanvasWidth(ref?.clientWidth)
                        setCanvasHeight(ref?.clientWidth * 0.71)
                    }
                }}
            >
                <Stage
                    ref={(ref) => (stageRef = ref)}
                    style={{
                        background: '#ffefff',
                        width: '100%',
                        height: canvasHeight,
                    }}
                    width={canvasWidth}
                    height={canvasHeight}
                >
                    <Layer>
                        {/*UNTUK DEFINE GAMBAR*/}
                        <Image
                            ref={(ref) => {
                                imageRef = ref
                            }}
                            width={canvasWidth}
                            height={canvasHeight}
                            image={imageBG}
                        />

                        {/*TULISAN DINAMIS*/}
                        <Text
                            align={'center'}
                            fontSize={((fontSize * 3) / 1000) * canvasHeight}
                            fontFamily={'Times New Roman'}
                            fill={textColor}
                            x={(canvasWidth * left) / 100}
                            y={(canvasHeight * top) / 100}
                            offsetY={(((fontSize * 3) / 1000) * canvasHeight) / 2}
                            offsetX={canvasWidth / 2}
                            width={canvasWidth}
                            text={
                                profileData?.member?.full_name
                                    ? profileData?.member?.full_name
                                    : 'Saya Sendiri'
                            }
                        />
                        <Text
                            align={'left'}
                            fontSize={((fontSizeNumber * 3) / 1000) * canvasHeight}
                            fontFamily={'Times New Roman'}
                            fontStyle={'bold'}
                            fill={'#000000'}
                            x={(canvasWidth * leftNumber) / 100}
                            y={(canvasHeight * topNumber) / 100}
                            // offsetX={canvasWidth / 2}
                            width={canvasWidth}
                            text={certNumPlaceholder}
                        />
                        <Text
                            align={'center'}
                            fontSize={((fontSizeYear * 3) / 1000) * canvasHeight}
                            fontFamily={'Times New Roman'}
                            fontStyle={'bold'}
                            fill={'#000000'}
                            x={(canvasWidth * leftYear) / 100}
                            y={(canvasHeight * topYear) / 100}
                            offsetX={canvasWidth / 2}
                            width={canvasWidth}
                            text={year}
                        />
                        <Text
                            align={'center'}
                            fontSize={((fontSizeHPI * 3) / 1000) * canvasHeight}
                            fontFamily={'Times New Roman'}
                            fontStyle={'bold'}
                            fill={'#000000'}
                            x={(canvasWidth * leftHPI) / 100}
                            y={(canvasHeight * topHPI) / 100}
                            offsetX={canvasWidth / 2}
                            width={canvasWidth}
                            text={
                                profileData?.member?.hpi_id
                                    ? profileData?.member?.hpi_id
                                    : 'HPI-01-1234'
                            }
                        />
                        {qrImage && (
                            <Image
                                image={qrImage}
                                x={(canvasWidth * leftQR) / 100}
                                y={(canvasHeight * topQR) / 100}
                                width={canvasWidth * 0.067}
                                height={canvasWidth * 0.067}
                            />
                        )}
                    </Layer>
                </Stage>
                <canvas ref={canvasRef} style={{ display: 'none' }} />
            </div>
        )
    }

    const pricesModal = (
        <Modal show={showPricesModal} size={'md'} onHide={() => setShowPricesModal(false)}>
            <Modal.Header
                closeButton
                style={{ borderBottom: 'none !important', background: '#333c47' }}
            >
                <p style={{ color: '#FFFFFF', fontSize: '1.1em' }}>
                    Perpanjangan Status Keanggotaan:
                    <br />
                    <b>{MemberType[profileData?.member?.role]}</b>
                </p>
            </Modal.Header>

            <Modal.Body>
                <div style={{ fontSize: '0.8em' }}>
                    <b>
                        Jumlah yang dipakai adalah yang dicetak tebal:{' '}
                        {MemberType[profileData?.member?.role]}
                    </b>
                </div>
                <hr></hr>

                <div style={{ fontSize: '0.8em' }} className={'mt-3'}>
                    {prices
                        .filter((p) => {
                            return p.name === 'PENUH' || p.name === 'MITRA'
                        })
                        .map((p) => {
                            return (
                                <Row
                                    style={{
                                        color: 'none',
                                        ...(profileData?.member?.role === p.name && {
                                            fontWeight: '700',
                                            color: 'black',
                                        }),
                                    }}
                                >
                                    <Col>{MemberType[p.name]}</Col>
                                    <Col>{formatter.format(p.price)}/tahun</Col>
                                </Row>
                            )
                        })}
                </div>
                {profileData?.member?.role == 'PENUH' && (
                    <>
                        <div className="mt-3 register-form-label">
                            CETAK KARTU ANGGOTA FISIK (OPSIONAL)
                        </div>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="checkedB"
                                    color="primary"
                                    onChange={(event) => {
                                        setPrintMemberCard(event.target.checked)
                                    }}
                                />
                            }
                            label={
                                <>
                                    Kami menyediakan opsi pencetakan kartu keanggotaan bagi Anda
                                    yang ingin memiliki bukti fisik keanggotaan. Biaya pencetakan
                                    kartu yang akan dikenakan adalah sebesar Rp100.000.
                                </>
                            }
                        />
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    disabled={
                        activeExtensionData ||
                        activeMemberData ||
                        !isOverDueMembership ||
                        moment() > moment(GRACE_PERIOD) ||
                        profileData?.member?.role === 'MUDA'
                    }
                    onClick={() => {
                        continuePayment()
                    }}
                >
                    Lanjutkan
                </Button>
            </Modal.Footer>
        </Modal>
    )

    const certificateModal = (
        <Modal show={!!selectedCertificate} size={'lg'} onHide={() => setSelectedCertificate(null)}>
            <Modal.Header
                closeButton
                style={{ borderBottom: 'none !important', background: '#333c47' }}
            >
                <p style={{ color: '#FFFFFF', fontSize: '1.1em' }}>
                    Dokumen Keanggotaan Profesional
                </p>
            </Modal.Header>

            <Modal.Body>
                {selectedCertificate?.certificate_url ? (
                    <>
                        <img
                            src={selectedCertificate.certificate_url}
                            alt="Dokumen Keanggotaan Profesional"
                            className="img-fluid mb-4 w-100"
                        />
                    </>
                ) : (
                    renderNewEditor()
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    disabled={qrValue === '' && !selectedCertificate}
                    onClick={() => {
                        try {
                            if (!qrRef.current) {
                                console.error('QR code container not available')
                                return
                            }

                            const canvasElement =
                                qrRef.current.querySelector('canvas')

                            const size = 300
                            const downloadCanvas = document.createElement('canvas')
                            downloadCanvas.width = size
                            downloadCanvas.height = size

                            const context = downloadCanvas.getContext('2d')
                            if (!context) {
                                console.error('check isi context', context)
                                return
                            }
                            context.fillStyle = 'white'
                            context.fillRect(0, 0, size, size)
                            context.drawImage(canvasElement, 0, 0, size, size)
                            try {
                                const pngUrl = downloadCanvas.toDataURL('image/png')
                                const link = document.createElement('a')
                                const fileName = qrValue !== '' ? `${qrValue}.png` : `${selectedCertificate?.certificate_token}.png`

                                link.download = fileName
                                link.href = pngUrl
                                link.click()
                            } catch (e) {
                                console.error('Error creating download link:', e)
                            }
                        } catch (error) {
                            console.error('Download failed:', error)
                        }
                    }}
                >
                    Unduh QR Dokumen
                </Button>
                <div style={{ display: 'none' }} ref={qrRef}>
                    <QRCode
                        qrStyle={'square'}
                        fgColor="#000000"
                        logoPaddingStyle={'circle'}
                        logoOpacity={0.8}
                        logoPadding={0}
                        removeQrCodeBehindLogo={true}
                        logoWidth={140}
                        value={getCertificateResultUrl()}
                        size={300}
                        ecLevel="H"
                    />
                </div>
            </Modal.Footer>
        </Modal>
    )

    const continuePayment = async () => {
        if (
            activeExtensionData ||
            activeMemberData ||
            !isOverDueMembership ||
            moment() > moment(GRACE_PERIOD) ||
            profileData?.member?.role === 'MUDA'
        ) {
            return Swal.fire({
                title: 'Belum dapat memperpanjang keanggotaan',
                text: 'Terjadi Kesalahan.',
                icon: 'info',
                confirmButtonText: 'Oke',
            })
        }
        if (
            moment(latestHistoryRegardlessOfValidity.valid_until)
                .subtract(90, 'days')
                .isBefore(new Date())
        ) {
            let modelMemberShip = new MemberShip()
            let body = {
                print_card: printMemberCard,
            }
            const result = await modelMemberShip.buy(body)
            fetchActiveMembership()
            window.location.href = result.transaction.snap_payment_url
        } else {
            Swal.fire({
                title: 'Belum dapat memperpanjang keanggotaan',
                text: 'Keanggotaan anda masih berlaku lebih dari 90 hari lagi, harap coba lagi nanti.',
                icon: 'info',
                confirmButtonText: 'Oke',
            })
        }
    }

    const renderStatusKeanggotaan = () => {
        console.log('INVD', invoiceData)

        if (
            membershipExpiryStatus === 'DEBT' ||
            membershipExpiryStatus === 'NON_ACTIVE' ||
            membershipExpiryStatus === 'JATUH_TEMPO'
        ) {
            return (
                <>
                    Status Keanggotaan : <b style={{ color: 'red' }}>Tidak Aktif</b>
                </>
            )
        }

        return (
            <>
                Status Keanggotaan : <b style={{ color: 'green' }}>Aktif</b>
            </>
        )
    }

    return (
        <>
            <ReminderDebtModal
                close={(is_close) => {
                    setShowReminderDialog(false)
                }}
                isOpen={showReminderDialog}
            />

            <Container className="text-left">
                {/* {(!profileData?.member?.hpi_id || !activeMemberData) &&
                    <Row>
                        <Col>
                            <Alert type="error" className='mx-0' errorMsg={'Please activate membership or complete payment'}></Alert>
                        </Col>
                    </Row>} */}
                <Row>
                    <Col>{!isValidMembership && <Alert errorMsg={validateMsg} />}</Col>
                </Row>
                {profileData?.member?.membership_creation_status === 'WAITING_FIRST_PAYMENT' && (
                    <Row>
                        <Col>
                            <Alert
                                backgroundColor={'#fff3cd'}
                                color={'#856404'}
                                type="warning"
                                className="mx-0"
                                errorMsg={
                                    'Harap menyelesaikan pembayaran pertama untuk melanjutkan proses pendaftaran.'
                                }
                            ></Alert>
                        </Col>
                    </Row>
                )}

                {profileData?.member?.membership_creation_status === 'WAITING_SK' && (
                    <Row>
                        <Col>
                            <Alert
                                backgroundColor={'#fff3cd'}
                                color={'#856404'}
                                type="warning"
                                className="mx-0"
                                errorMsg={'Kami sedang memproses keanggotaan Saudara.'}
                            ></Alert>
                        </Col>
                    </Row>
                )}
                {membershipExpiryStatus === 'DEBT' && (
                    <Row>
                        <Col>
                            <Alert
                                // backgroundColor={"#fff3cd"} color={"#856404"}
                                className="mx-0"
                                errorMsg={`Keanggotaan Saudara telah jatuh tempo dan akun Sihapei Saudara telah dinonaktifkan.`}
                            ></Alert>
                        </Col>
                    </Row>
                )}
                {membershipExpiryStatus === 'JATUH_TEMPO' && (
                    <Row>
                        <Col>
                            <Alert
                                backgroundColor={'#fff3cd'}
                                color={'#856404'}
                                type="warning"
                                className="mx-0"
                                errorMsg={`Keanggotaan Saudara telah jatuh tempo pada ${moment(
                                    latestHistoryRegardlessOfValidity?.valid_until,
                                ).format(
                                    'DD MMM YYYY',
                                )}. Harap segera melakukan perpanjangan keanggotaan sebelum ${moment(
                                    gracePeriod,
                                ).format(
                                    'DD MMM YYYY',
                                )} atau fitur di akun Sihapei Saudara akan dinonaktifkan.`}
                            ></Alert>
                        </Col>
                    </Row>
                )}
                {membershipExpiryStatus === 'NON_ACTIVE' && (
                    <Row>
                        <Col>
                            <Alert
                                backgroundColor={'#fff3cd'}
                                color={'#856404'}
                                type="warning"
                                className="mx-0"
                                errorMsg={`Keanggotaan saudara sudah tidak aktif dan tidak dapat diperpanjang, harap untuk melakukan peningkatan status keanggotaan sebelum ${moment(
                                    gracePeriod,
                                ).format(
                                    'DD MMM YYYY',
                                )} atau akun Sihapei Saudara akan dinonaktifkan.`}
                            ></Alert>
                        </Col>
                    </Row>
                )}
                {/* {
              membershipExpiryStatus === "RELEASE_GRACE_PERIOD_WARNING" &&
              <Row>
                <Col>
                  <Alert
                      backgroundColor={"#fff3cd"} color={"#856404"}
                      type="warning" className='mx-0' errorMsg={`Keanggotaan Saudara telah jatuh tempo pada ${moment(latestHistoryRegardlessOfValidity?.valid_until).format("DD MMM YYYY")}. Harap segera melakukan perpanjangan keanggotaan sebelum ${moment(releaseGracePeriod).format("DD MMM YYYY")} atau fitur di akun Sihapei Saudara akan dinonaktifkan.`}></Alert>
                </Col>
              </Row>
          } */}
                {membershipExpiryStatus === 'AKAN_JATUH_TEMPO' && (
                    <Row>
                        <Col>
                            <Alert
                                backgroundColor={'#fff3cd'}
                                color={'#856404'}
                                type="warning"
                                className="mx-0"
                                errorMsg={`Keanggotaan Saudara akan segera jatuh tempo pada ${moment(
                                    latestHistoryRegardlessOfValidity?.valid_until,
                                ).format(
                                    'DD MMM YYYY',
                                )}. Harap segera melakukan perpanjangan keanggotaan Saudara dalam masa perpanjangan keanggotaan mulai awal Januari sampai 30 April ${
                                    moment(latestHistoryRegardlessOfValidity?.valid_until).get(
                                        'year',
                                    ) + 1
                                } bagi anggota profesional, dan sampai 31 Januari ${
                                    moment(latestHistoryRegardlessOfValidity?.valid_until).get(
                                        'year',
                                    ) + 1
                                } bagi aspiran.`}
                            ></Alert>
                        </Col>
                    </Row>
                )}
                {profileData?.member?.membership_upgrade_status === 'WAITING_SK' && (
                    <Row>
                        <Col>
                            <Alert
                                backgroundColor={'#fff3cd'}
                                color={'#856404'}
                                type="warning"
                                className="mx-0"
                                errorMsg={
                                    'Kami sedang memproses peningkatan status keanggotaan Saudara.'
                                }
                            ></Alert>
                        </Col>
                    </Row>
                )}

                {profileData?.member?.membership_upgrade_status === 'WAITING' &&
                    profileData?.member?.hpi_id && (
                        <Row>
                            <Col>
                                <Alert
                                    backgroundColor={'#fff3cd'}
                                    color={'#856404'}
                                    type="warning"
                                    className="mx-0"
                                    errorMsg={
                                        'Permintaan penaikan tingkat anda sedang di verifikasi oleh sekretariat'
                                    }
                                ></Alert>
                            </Col>
                        </Row>
                    )}

                {invoiceData &&
                    invoiceData.some(
                        (i) =>
                            i.status === 'WAITING' && i.transaction?.type === 'UPGRADE_MEMBERSHIP',
                    ) && (
                        <Row>
                            <Col>
                                <Alert
                                    type="error"
                                    className="mx-0"
                                    errorMsg={
                                        'Harap menyelesaikan pembayaran untuk melanjutkan proses peningkatan status keanggotaan Saudara.'
                                    }
                                ></Alert>
                            </Col>
                        </Row>
                    )}
                <Row>
                    <Col md={6}>
                        <Card>
                            <Container>
                                <Row>
                                    <Col
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                        }}
                                        md={12}
                                    >
                                        <img
                                            src={
                                                profileData?.member?.profile_picture_url
                                                    ? profileData.member.profile_picture_url
                                                    : profilePicture
                                            }
                                            style={{
                                                width: 130,
                                                objectFit: 'contain',
                                            }}
                                            alt="user"
                                        />
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                padding: 10,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontFamily: 'Signika',
                                                    fontWeight: '600',
                                                    color: '#8e8e8e',
                                                }}
                                            >
                                                Nama Lengkap
                                            </div>
                                            <div
                                                style={{
                                                    fontFamily: 'Signika',
                                                    fontWeight: '600',
                                                    marginBottom: 15,
                                                }}
                                            >
                                                {profileData?.member?.full_name}
                                            </div>
                                            <div
                                                style={{
                                                    fontFamily: 'Signika',
                                                    fontWeight: '600',
                                                    color: '#8e8e8e',
                                                }}
                                            >
                                                HPI ID
                                            </div>
                                            <div
                                                style={{
                                                    fontFamily: 'Signika',
                                                    fontWeight: '600',
                                                    marginBottom: 15,
                                                }}
                                            >
                                                {profileData?.member?.hpi_id}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Card>
                    </Col>

                    <Col md={6}>
                        <Card
                            style={{
                                height: '100%',
                            }}
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    padding: 10,
                                    height: '100%',
                                }}
                            >
                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        color: '#8e8e8e',
                                    }}
                                >
                                    {renderStatusKeanggotaan()}
                                </div>
                                {profileData?.member?.role && (
                                    <>
                                        <div
                                            style={{
                                                fontFamily: 'Signika',
                                                fontWeight: '600',
                                                color: '#8e8e8e',
                                            }}
                                        >
                                            Keanggotaan :{' '}
                                            <b> {MemberType[profileData?.member?.role]}</b>
                                        </div>
                                    </>
                                )}
                                {(profileData?.member?.upgrade_status ||
                                    profileData?.member?.upgrade_status === 'WAITING') && (
                                    <>
                                        <div
                                            style={{
                                                fontFamily: 'Signika',
                                                fontWeight: '600',
                                                color: '#8e8e8e',
                                            }}
                                        >
                                            Upgrade Status :{' '}
                                            <b style={{ color: 'blue' }}>On Progress</b>
                                        </div>
                                    </>
                                )}
                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        color: '#8e8e8e',
                                    }}
                                >
                                    Anggota sejak :{' '}
                                    <b style={{ color: 'black' }}>
                                        {moment(profileData?.member?.entry_date).format(
                                            'DD MMM YYYY',
                                        )}
                                    </b>
                                </div>
                                <div
                                    style={{
                                        fontFamily: 'Signika',
                                        fontWeight: '600',
                                        color: '#8e8e8e',
                                    }}
                                >
                                    Aktif hingga :{' '}
                                    <b style={{ color: 'black' }}>
                                        {latestHistoryRegardlessOfValidity
                                            ? moment(
                                                  latestHistoryRegardlessOfValidity?.valid_until,
                                              ).format('DD MMM YYYY')
                                            : '-'}
                                    </b>
                                </div>
                                {/*<div style={{*/}
                                {/*    fontFamily: 'Signika',*/}
                                {/*    fontWeight: '600',*/}
                                {/*    color: '#8e8e8e',*/}
                                {/*}}>*/}
                                {/*    Last Extension : <b style={{color : 'black'}}>25 Feb 2022</b>*/}
                                {/*</div>*/}
                            </div>
                        </Card>
                    </Col>
                </Row>

                {/* Sekarang tombol cuma muncul kalau di tgl 1 januari tiap taonnya, berarti udah gk active member data lagi */}
                {!activeExtensionData &&
                    !activeMemberData &&
                    isOverDueMembership &&
                    moment() < moment(GRACE_PERIOD) &&
                    profileData?.member?.role !== 'MUDA' && (
                        <Button
                            style={{ marginTop: 15 }}
                            className="mr-1"
                            onClick={() => {
                                if (isOverDueMembership) {
                                    setShowPricesModal(true)
                                }
                            }}
                        >
                            Perpanjang Keanggotaan
                        </Button>
                    )}

                {/* {!!activeMemberData && (
                    <>
                        {profileData?.member?.sk_url ? (
                            <a href={profileData.member.sk_url} target={'_blank'}>
                                <Button
                                    // disabled={!profileData.sk_url}
                                    style={{ marginTop: 15, background: Palette.PRIMARY }}
                                    className="mr-1"
                                >
                                    Unduh SK
                                </Button>
                            </a>
                        ) : (
                            <Button
                                // disabled={!profileData.sk_url}
                                style={{ marginTop: 15 }}
                                className="mr-1"
                                onClick={() => {
                                    console.log(profileData?.member?.sk_url)
                                    Swal.fire({
                                        title: 'Kami sedang memproses keanggotaan Saudara.',
                                        text: 'Harap menunggu beberapa saat. Jika masih belum diproses, harap menghubungi Sekretariat.',
                                        icon: 'info',
                                        confirmButtonText: 'Oke',
                                    })
                                }}
                            >
                                Unduh SK
                            </Button>
                        )}
                    </>
                )} */}

                {(profileData?.member?.hpi_id && profileData?.member?.role) === 'MUDA' && (
                    // (profileData?.member?.hpi_id && profileData?.member?.role) === 'MUDA' &&
                    <Button
                        style={{ marginTop: 15 }}
                        className="mr-1"
                        onClick={() => {
                            switch (profileData?.member?.membership_upgrade_status) {
                                case 'WAITING':
                                    Swal.fire(
                                        'Menunggu persetujuan dari Sekretariat',
                                        'Saat ini pengajuan Saudara sedang kami tinjau, mohon menunggu persetujuan dari Sekretariat.',
                                        'info',
                                    )
                                    break

                                case 'APPROVED':
                                    Swal.fire(
                                        'Keanggotaan Saudara telah disetujui',
                                        'Harap selesaikan pembayaran untuk menyelesaikan peningkatan status keanggotaan.',
                                        'info',
                                    )
                                    break

                                case 'REJECTED':
                                    Swal.fire({
                                        title: 'Pengajuan peningkatan status Saudara ditolak.',
                                        text: `Mohon maaf, peningkatan status Saudara kami tolak karena: ${profileData.member.membership_upgrade_rejected_reason}`,
                                        icon: 'error',
                                        showCancelButton: true,
                                        confirmButtonColor: '#3085d6',
                                        cancelButtonColor: '#d33',
                                        confirmButtonText: 'Coba Lagi',
                                        cancelButtonText: 'Batal',
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            setProfileData({
                                                ...profileData,
                                                member: {
                                                    ...profileData.member,
                                                    membership_upgrade_status: null,
                                                },
                                            })
                                            setShowUpgradeModal(true)
                                        }
                                    })
                                    break

                                default:
                                    setShowUpgradeModal(true)
                                    break
                            }
                        }}
                    >
                        Peningkatan Status Keanggotaan
                        {profileData.member.membership_upgrade_status === 'REJECTED' && (
                            <span class="ml-1 badge badge-pill badge-danger">!</span>
                        )}
                    </Button>
                )}

                {profileData?.member?.hpi_id &&
                    (profileData?.member?.role === 'PENUH' ||
                        profileData?.member?.role === 'MITRA') && (
                        <>
                            {profileData.latest_membership &&
                                moment(profileData.latest_membership.valid_until).isAfter(
                                    moment(),
                                ) && (
                                    <>
                                        <Button
                                            style={{ marginTop: 15, marginRight: 5 }}
                                            onClick={() => {
                                                console.log(
                                                    'isi profile data',
                                                    moment(
                                                        profileData.latest_membership.valid_until,
                                                    ).isAfter(moment()),
                                                )
                                                setShowMemberCard(true)
                                            }}
                                            variant="outline-info"
                                        >
                                            Lihat Kartu Anggota
                                        </Button>
                                    </>
                                )}

                            <Button
                                style={{ marginTop: 15 }}
                                onClick={() => {
                                    try {
                                        if (!qrRef.current) {
                                            console.error('QR code container not available')
                                            return
                                        }

                                        const canvasElement = qrRef.current.querySelector('canvas')

                                        const size = 300
                                        const downloadCanvas = document.createElement('canvas')
                                        downloadCanvas.width = size
                                        downloadCanvas.height = size

                                        const context = downloadCanvas.getContext('2d')
                                        if (!context) {
                                            console.error('check isi context', context)
                                            return
                                        }
                                        context.fillStyle = 'white'
                                        context.fillRect(0, 0, size, size)
                                        context.drawImage(canvasElement, 0, 0, size, size)
                                        try {
                                            const pngUrl = downloadCanvas.toDataURL('image/png')
                                            const link = document.createElement('a')
                                            const fileName = `${
                                                profileData?.member?.full_name || 'qrcode'
                                            }-${profileData?.member?.hpi_id || 'id'}.png`

                                            link.download = fileName
                                            link.href = pngUrl
                                            link.click()
                                        } catch (e) {
                                            console.error('Error creating download link:', e)
                                        }
                                    } catch (error) {
                                        console.error('Download failed:', error)
                                    }
                                }}
                                variant="outline-dark"
                            >
                                Unduh QR
                            </Button>
                        </>
                    )}
                <div style={{ display: 'none' }} ref={qrRef}>
                    <QRCode
                        qrStyle={'square'}
                        fgColor="#000000"
                        logoPaddingStyle={'circle'}
                        logoOpacity={0.8}
                        logoPadding={0}
                        removeQrCodeBehindLogo={true}
                        logoWidth={140}
                        logoImage={Logo}
                        value={getMemberResultUrl()}
                        size={300}
                        ecLevel="H"
                    />
                </div>

                <MembershipModal
                    data={prices.filter((p) => p.name === profileData?.member?.role)}
                    invoiceData={invoiceData}
                    displayModal={showMembership}
                    toogleSelected={(showMembership) => setShowMemberShip(false)}
                />
                {pricesModal}
                {certificateModal}
                <Row style={{ marginBottom: 15 }}>
                    <Col>
                        <MobTable
                            columns={columns}
                            data={invoiceData}
                            interactions={interactions}
                            interactionsLabelStyles={{ fontSize: '0.7em' }}
                        />
                    </Col>
                </Row>
            </Container>

            <InvoiceDetailModal
                profile={profileData}
                show={!!selectedInvoiceDetail}
                close={() => setSelectedInvoiceDetail(null)}
                data={selectedInvoiceDetail}
            />

            <MemberCardModal
                data={
                    latestExtensionData
                        ? {
                              ...profileData,
                              latestExtensionData,
                              ...profileData.member,
                              member_card: memberCarData,
                          }
                        : profileData
                }
                show={showMemberCard}
                close={() => setShowMemberCard(false)}
            />

            <UpgradeMembershipModal
                data={profileData}
                show={showUpgradeModal}
                close={() => setShowUpgradeModal(false)}
            />
        </>
    )
}

export default InvoicePage
